"use client";
/*
 * Documentation:
 * DC_Text_Blockquote — https://app.subframe.com/4f62853ee923/library?component=DC_Text_Blockquote_a77af3c6-41f7-4178-bc8a-08709210cacc
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface SubtitleProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode;
  className?: string;
}

const Subtitle = React.forwardRef<HTMLSpanElement, SubtitleProps>(
  function Subtitle(
    { children, className, ...otherProps }: SubtitleProps,
    ref
  ) {
    return children ? (
      <span
        className={SubframeUtils.twClassNames(
          "text-caption font-caption text-subtext-color",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        {children}
      </span>
    ) : null;
  }
);

interface Dc_Text_BlockquoteRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  text?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Text_BlockquoteRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Text_BlockquoteRootProps
>(function Dc_Text_BlockquoteRoot(
  {
    text,
    subtitle,
    children,
    className,
    ...otherProps
  }: Dc_Text_BlockquoteRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full flex-col items-start gap-2 border-l-[5px] border-solid border-neutral-border px-4 py-4",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {text ? (
        <span className="text-body font-body text-default-font comp-blockquote-text">
          {text}
        </span>
      ) : null}
      {children ? (
        <div className="flex items-start gap-2">{children}</div>
      ) : null}
    </div>
  );
});

export const Dc_Text_Blockquote = Object.assign(Dc_Text_BlockquoteRoot, {
  Subtitle,
});
